module.exports = {
  // api key
  signUpApiKey: 'REACT_APP_APIKEY',
  backEndBaseUrl: 'https://REACT_APP_BACKENDBASEURL',
  frontEndUrl: 'https://REACT_APP_FRONTENDURL',
  captchaSiteKey: "REACT_APP_CAPTCA"
};
